module.exports = __webpack_public_path__ + "static/table_english_6-9686cbda899c24753741705c9bdf2304.png";